import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkshopCreateEditModalComponent } from './workshop-create-edit-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    WorkshopCreateEditModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    WorkshopCreateEditModalComponent
  ]
})
export class WorkshopCreateEditModalModule { }
